
import Event = createjs.Event;

export class Poker2RankingDataEvent extends Event {
    public static CHANGE_RANKING_DATA: string = "changeRankingData";
    public static CHANGE_RANKING_TOPAVATAR_DATA: string = "changeRankingTopAvatarData";
    public static CHANGE_RANKING_AVATAR_DATA: string = "changeRankingAvatarData";
    public static CHANGE_JOUSTRANKING_DATA: string = "changeJoustRankingData";
    public static CHANGE_HALLOFFAME_DATA: string = "changeHallofFameData";
    public static CHANGE_RANKING_TAB: string = "changeRankingTab";
    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
